const keyUser = "campla_user";
const keyToken = "campla_token";
const keyTableConfigs = "campla_table_configs";

class StorageService {
  static setToken(v) {
    StorageService.set(keyToken, v);
  }

  static getToken() {
    return StorageService.getPrimitive(keyToken);
  }

  static setUser(v) {
    StorageService.set(keyUser, v);
  }

  static getUser() {
    return StorageService.getReferenceType(keyUser);
  }

  static getTableConfigs() {
    return StorageService.getReferenceType(keyTableConfigs);
  }

  static setTableConfigValue(tableId, tableKey, tableValue) {
    let tableConfigs = StorageService.getTableConfigs() || {};

    let valueUpdate = {};
    valueUpdate[tableKey] = tableValue;

    tableConfigs[tableId] = Object.assign(
      {},
      tableConfigs[tableId],
      valueUpdate
    );
    StorageService.set(keyTableConfigs, tableConfigs);
  }

  static getTableConfigValue(tableId, tableKey) {
    let tableConfigs = StorageService.getTableConfigs();
    if (tableConfigs) {
      let tableConfig = tableConfigs[tableId];
      if (tableConfig) return tableConfig[tableKey];
    }
  }

  static set(k, v, type) {
    if (typeof type !== "undefined") {
      switch (type) {
        case "map":
          v = JSON.stringify([...v.entries()]);
          break;
        default:
      }
    }
    try {
      if (Array.isArray(v) || typeof v === "object") {
        sessionStorage.setItem(k, JSON.stringify(v));
      } else {
        sessionStorage.setItem(k, v);
      }
    }catch (err){
      console.error(err);
    }
  }


  static getReferenceType(k, type) {
    switch (type) {
      case "map":
        return sessionStorage.getItem(k)
          ? JSON.parse(sessionStorage.getItem(k)).reduce(
              (m, [key, val]) => m.set(key, val),
              new Map()
            )
          : null;
      default:
        return sessionStorage.getItem(k)
          ? JSON.parse(sessionStorage.getItem(k))
          : null;
    }
  }

  static getPrimitive(k) {
    return sessionStorage.getItem(k);
  }

  static remove(k) {
    if (sessionStorage.getItem(k)) sessionStorage.removeItem(k);
  }

  static clear() {
    sessionStorage.clear();
  }

  static getPaginationTableIndex(view) {
    const paginationTableIndexes = this.getReferenceType("paginationTable");
    if (!paginationTableIndexes) return null;
    if (paginationTableIndexes[view]) {
      return paginationTableIndexes[view];
    }
  }

  static setPaginationTableIndex(view, index) {
    const paginationTableIndexes =
      this.getReferenceType("paginationTable") || {};
    paginationTableIndexes[view] = index;
    this.set("paginationTable", paginationTableIndexes);
  }
}

export default StorageService;
